// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cthhtOhzzzEPsH .board-canvas:last-child,
.cthhtOhzzzEPsH .plugin-board-bar {
  margin-bottom: 62px;
  transition: margin 0.2s ease-in-out;
}
.cthhtOhzzzEPsH .board-canvas:has(#board) {
  margin-bottom: 0;
}
.Sw27XHcI_ZNr5N .board-canvas:last-child,
.Sw27XHcI_ZNr5N .plugin-board-bar {
  margin-bottom: 26px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardPanelPadding": `cthhtOhzzzEPsH`,
	"multiplePanelPadding": `Sw27XHcI_ZNr5N`
};
export default ___CSS_LOADER_EXPORT___;
